import { removeItemFromBasket, selectBasketCanEdit, selectBasketIsEmpty } from 'containers/OrderDetails/basketSlice'
import { ReactComponent as Ldz02Logo } from 'assets/icons/ldz02Logo-full.svg'
import TimerProvider from 'containers/Header/context/Timer/Provider'
import ConfirmationPopup from 'components/popups/ConfirmationPopup'
import { useReduxDispatch, useReduxSelector } from 'store'
import BasketPopup from 'containers/Header/basket/Popup'
import BasketIcon from 'containers/Header/basket/Icon'
import LoginPopup from 'containers/Login/LoginPopup'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import usePopupState from 'hooks/usePopupState'
import { useHistory } from 'react-router-dom'
import LanguageSelect from './LanguageSelect'
import { POPUPS } from 'containers/Home'
import './style.scss'

interface NavbarProps {
  isBasket: boolean
  isCategories: boolean
  isBlack: boolean
  isLoggedIn: boolean
  isGray?: boolean
}

type Popup = {
  type: 'removeCartPosition'
  cartId: string
} | {
  type: 'basket' | 'login'
}

const type = process.env.REACT_APP_TYPE

const Navbar: React.FC<NavbarProps> = ({ isCategories, isBlack, isLoggedIn, isGray }) => {
  const canEdit = useReduxSelector(selectBasketCanEdit)
  const basketIsEmpty = useReduxSelector(selectBasketIsEmpty)
  const { popup } = usePopupState<Popup>()

  const isBasketExpanded = popup?.type === 'basket'

  const dispatch = useReduxDispatch()
  const { t } = useTranslation('menu')
  const { push, goBack } = useHistory()

  return (
    <TimerProvider>
      <div className={`navbar ${isBlack ? '--black' : ''} ${isGray ? '--gray' : ''}`}>
        {type === 'mm'
          ? <div
            className="navbar__logo"
            onClick={() => {
              push('/map')
            }}>
            <i className='icon icon--logo' />
            <span className='--secFont'>Magazynomaty</span>
          </div>
          : <div
            className="navbar__logo"
            onClick={() => {
              push('/')
            }}>
            {type === 'ldz01'
              ? <>
                <i className='icon icon--logo s32' />
                <span className='--secFont'>VIP-BOX</span>
              </>
              : type === 'ldz02'
                ? <Ldz02Logo />
                : <i className={`icon icon--${process.env.REACT_APP_TYPE}-full-logo`} />}
          </div>}
        <div className="navbar__categories">
          {isCategories && type === 'mm' && <>
            <span className='--selected'>{t('selfStorage')}</span>
            <span
              onClick={() => {
                push(window.location.pathname, LOCATION_STATES.popup(POPUPS.magMobile))
              }}>
              MagMobile
            </span>
            <span
              onClick={() => {
                push(window.location.pathname, LOCATION_STATES.popup(POPUPS.magStore))
              }}>
              MagStore
            </span>
          </>}
        </div>
        <div className="navbar__buttons">
          <LanguageSelect />
          {isLoggedIn
            ? <button
              className='btn btn--primary'
              onClick={() => push('/')}>
              {t('customerPanel')}
            </button>
            : <button
              className='btn btn--primary'
              onClick={() => push('/login')}>
              {t('logIn')}
            </button>}
          {(basketIsEmpty || canEdit === 0)
            ? null
            : <BasketIcon
              action={() => {
                if (isBasketExpanded) goBack()
                else push(window.location.pathname, LOCATION_STATES.popup({ type: 'basket' }))
              }}
            />}
        </div>
      </div>
      {isBasketExpanded && <BasketPopup isDesktop />}
      {popup?.type === 'login' && <LoginPopup />}
      {popup?.type === 'removeCartPosition' && <ConfirmationPopup
        okAction={() => {
          dispatch(removeItemFromBasket({ removeIdentifiers: [popup.cartId] }))
          goBack()
        }}
      />}
    </TimerProvider>)
}

export default Navbar